import React, { useState } from 'react';
import { EyeTwoTone } from '@ant-design/icons';
import { Drawer, Descriptions } from 'antd';

const ShowCompany = ({ item }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const hideDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <>
    {console.log(item)}
      <EyeTwoTone key="view" onClick={showDrawer} />
      <Drawer
        title={item.name}
        visible={drawerVisible}
        closable={true}
        onClose={hideDrawer}
        width="70%"
        bodyStyle={{ padding: '16px', overflow: 'auto' }}
      >
        <Descriptions column={1}>
          <Descriptions.Item label="Name">{item.name}</Descriptions.Item>
          <Descriptions.Item label="Address">{item.address}</Descriptions.Item>
          <Descriptions.Item label="URL">{item.url}</Descriptions.Item>
          <Descriptions.Item label="Description">{item.description}</Descriptions.Item>
          <Descriptions.Item label="Country">{item.country?.name}</Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
};

export default ShowCompany;
